// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"ad000086","793":"ad000086","833":"ad000086"}[chunkId] + ".chunk.css";
};